module.exports = __webpack_public_path__ + "img/finance_7.b9fd30d7.png";